import {SvgIcon} from './SvgIcon'

export const RotatingSyncIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-amber-300',
  strokeWidth = 1.5,
  fillColor = 'none',
  classes = '',
  ariaLabel = 'Rotating Sync Icon',
}) => (
  <svg
    aria-label={ariaLabel}
    className={`stroke-current ${strokeColor} ${classes}`}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.875 10.0008C16.875 13.934 13.6916 17.1257 9.75833 17.1257C5.825 17.1257 3.18083 13.0007 3.18083 13.0007M3.18083 13.0007H6.49166M3.18083 13.0007V16.6673M3.125 10.0008C3.125 6.06742 5.82583 2.87575 9.75916 2.87575C14.6175 2.87575 16.8183 7.00075 16.8183 7.00075M16.8183 7.00075H13.5075M16.8183 7.00075V3.33409"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CrossCircleIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-red-400',
  strokeWidth = 1.5,
  fillColor = 'none',
  classes = '',
  ariaLabel = 'Cross Circle Icon',
}) => (
  <svg
    className={`stroke-current ${strokeColor} ${classes}`}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      d="M3.95837 10.0007C3.95837 6.66393 6.66332 3.95898 10 3.95898C13.3368 3.95898 16.0417 6.66393 16.0417 10.0007C16.0417 13.3374 13.3368 16.0423 10 16.0423C6.66332 16.0423 3.95837 13.3374 3.95837 10.0007Z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 7.5L12.5 12.5M7.5 12.5L12.5 7.5"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckmarkCircleIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-emerald-300',
  strokeWidth = 1.5,
  fillColor = 'none',
  classes = '',
  ariaLabel = 'Checkmark Circle Icon',
}) => (
  <svg
    className={`stroke-current ${strokeColor} ${classes}`}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      d="M3.95837 10.0007C3.95837 6.66393 6.66332 3.95898 10 3.95898C13.3368 3.95898 16.0417 6.66393 16.0417 10.0007C16.0417 13.3374 13.3368 16.0423 10 16.0423C6.66332 16.0423 3.95837 13.3374 3.95837 10.0007Z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 10.625L8.48644 11.3953C8.77288 12.0058 9.62804 12.041 9.96365 11.4561L11.875 8.125"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const GlobeIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.25 12C15.25 16.5 13.2426 19.25 12 19.25C10.7574 19.25 8.75 16.5 8.75 12C8.75 7.5 10.7574 4.75 12 4.75C13.2426 4.75 15.25 7.5 15.25 12Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12H19"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EyeIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = '#919699',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M19.25 12C19.25 13 17.5 18.25 12 18.25C6.5 18.25 4.75 13 4.75 12C4.75 11 6.5 5.75 12 5.75C17.5 5.75 19.25 11 19.25 12Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChartIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75Z"
      stroke="white"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 15.25V9.75"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.25 15.25V9.75"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.25V12.75"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ThreeDotsIcons: SvgIcon = ({width = 10, height = 3, classes}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <g id=". . .">
      <path
        d="M0 1.59034C0 1.32901 0.0886667 1.10734 0.266 0.925344C0.448 0.743344 0.676667 0.652344 0.952 0.652344C1.22733 0.652344 1.46067 0.743344 1.652 0.925344C1.84333 1.10734 1.939 1.32901 1.939 1.59034C1.939 1.84701 1.84333 2.06401 1.652 2.24134C1.46067 2.41401 1.22733 2.50034 0.952 2.50034C0.676667 2.50034 0.448 2.41168 0.266 2.23434C0.0886667 2.05701 0 1.84234 0 1.59034Z"
        fill="#919699"
      />
      <path
        d="M3.89867 1.59034C3.89867 1.32901 3.98734 1.10734 4.16467 0.925344C4.34667 0.743344 4.57534 0.652344 4.85067 0.652344C5.12601 0.652344 5.35934 0.743344 5.55067 0.925344C5.742 1.10734 5.83767 1.32901 5.83767 1.59034C5.83767 1.84701 5.742 2.06401 5.55067 2.24134C5.35934 2.41401 5.12601 2.50034 4.85067 2.50034C4.57534 2.50034 4.34667 2.41168 4.16467 2.23434C3.98734 2.05701 3.89867 1.84234 3.89867 1.59034Z"
        fill="#919699"
      />
      <path
        d="M7.79734 1.59034C7.79734 1.32901 7.88601 1.10734 8.06334 0.925344C8.24534 0.743344 8.47401 0.652344 8.74934 0.652344C9.02468 0.652344 9.25801 0.743344 9.44934 0.925344C9.64068 1.10734 9.73634 1.32901 9.73634 1.59034C9.73634 1.84701 9.64068 2.06401 9.44934 2.24134C9.25801 2.41401 9.02468 2.50034 8.74934 2.50034C8.47401 2.50034 8.24534 2.41168 8.06334 2.23434C7.88601 2.05701 7.79734 1.84234 7.79734 1.59034Z"
        fill="#919699"
      />
    </g>
  </svg>
)

export const BriefcaseIcon: SvgIcon = ({
  width = 10,
  height = 10,
  classes,
  strokeColor = 'text-dope-cyan-dark',
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    role="img"
    aria-label="Briefcase Icon"
  >
    <g id="briefcase">
      <path
        id="Vector"
        d="M1.98047 4.0638C1.98047 3.60356 2.35356 3.23047 2.8138 3.23047H7.1888C7.64904 3.23047 8.02214 3.60356 8.02214 4.0638V7.1888C8.02214 7.64904 7.64904 8.02213 7.1888 8.02213H2.8138C2.35356 8.02213 1.98047 7.64904 1.98047 7.1888V4.0638Z"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M3.64453 3.1263V2.8138C3.64453 2.35356 4.01763 1.98047 4.47786 1.98047H5.51953C5.97977 1.98047 6.35286 2.35356 6.35286 2.8138V3.1263"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M2.08203 5.51953H7.91536"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M3.64453 4.89453V5.9362"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M6.35547 4.89453V5.9362"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export const UsersIcon: SvgIcon = ({
  width = 10,
  height = 10,
  classes,
  strokeColor = '',
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    stroke={strokeColor}
    fill="none"
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
    role="img"
    aria-label="Users Icon"
  >
    <g id="users">
      <path
        id="Vector"
        d="M2.40806 8.01953H5.50666C5.74187 8.01953 5.92694 7.8244 5.88007 7.59391C5.75067 6.95754 5.32806 5.83203 3.95736 5.83203C2.58666 5.83203 2.16405 6.95754 2.03465 7.59391C1.98778 7.8244 2.17285 8.01953 2.40806 8.01953Z"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M6.5625 5.83203C7.42866 5.83203 7.78342 6.72698 7.92662 7.37202C8.00396 7.72038 7.72221 8.01953 7.36536 8.01953H6.97917"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M5.10417 3.1263C5.10417 3.75913 4.59116 4.27214 3.95833 4.27214C3.32551 4.27214 2.8125 3.75913 2.8125 3.1263C2.8125 2.49348 3.32551 1.98047 3.95833 1.98047C4.59116 1.98047 5.10417 2.49348 5.10417 3.1263Z"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M6.14453 4.27214C6.77736 4.27214 7.1862 3.75913 7.1862 3.1263C7.1862 2.49348 6.77736 1.98047 6.14453 1.98047"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export const LaptopIcon: SvgIcon = ({
  width = 11,
  height = 10,
  classes,
  strokeColor = '',
  datacy,
  strokeWidth = '0.75',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    stroke={strokeColor}
    fill="none"
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M8.43846 6.04297L8.74933 7.51963C8.80386 7.77861 8.60626 8.02214 8.3416 8.02214H3.32698C3.06232 8.02214 2.86473 7.77861 2.91925 7.51963L3.23012 6.04297M8.43846 5.9388V2.39714C8.43846 2.16702 8.25191 1.98047 8.02179 1.98047H3.64679C3.41667 1.98047 3.23012 2.16702 3.23012 2.39714V5.9388H8.43846Z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
